export default __webpack_public_path__ + "static/media/2663517.56aedf34.jpg";